function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23.973 16.296c-.055.293-.19.573-.408.8L12.437 28.698a.962.962 0 01-1.401 0l-.746-.778a1.064 1.064 0 010-1.46L20.322 16 10.29 5.54a1.064 1.064 0 010-1.46l.746-.777a.962.962 0 011.4 0l11.129 11.601c.362.379.498.904.408 1.392z",
  fill: "currentColor"
})));